import { render, staticRenderFns } from "./ComprobanteAPagar.vue?vue&type=template&id=b0204640&"
import script from "./ComprobanteAPagar.vue?vue&type=script&lang=js&"
export * from "./ComprobanteAPagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports